import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'HIndexFilter',
  pure: false
})
export class HIndexPipe implements PipeTransform {

  // transform(items: any, filter: any): any {
  //   let currentfilter = filter["H Index"].data;

  //   if (!items) return [];

  //   if (currentfilter.length == 0) return items;

  //   let start, end;
  //   var data = [];
  //   for(let i=0;i<currentfilter.length; i++)
  //   {
  //     start = Number(currentfilter[i].split("-",2)[0].trim());
  //     end = Number(currentfilter[i].split("-",2)[1].trim());

  //     items.filter(result => {
  //       if(result.h_index>= start && result.h_index<=end){
  //           data.push(result);
  //           return result;
  //         }
  //       })
  //   }
  //   return [...data];
  // }

  transform(array: any[], min: number, max: number): any[] {
    if (!array || array.length === 0) {
      return [];
    }
    if (min === 0 && max === 0) {
      return array;
    }

    return array.filter(item => item.h_index >= min && item.h_index <= max);
  }
}
